import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/context/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="faq" className="section-y bg-white" data-testid="faq-section">
      <div className="container-x grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-4">
          <span className="overline">{t.faq.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
            {t.faq.title}
          </h2>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="divide-y divide-brand-mist border-y border-brand-mist">
            {t.faq.items.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-none" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 md:py-6 text-left text-base md:text-lg font-medium text-brand-ink hover:no-underline hover:text-brand-graphite">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 pr-6 text-brand-graphite leading-relaxed text-[15px] md:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
